export default __webpack_public_path__ + "static/media/trash.b2a8cc03.svg";